import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ id, ariaLabel, className, text, onClick, style }) => (
  <button
    id={id}
    aria-label={ariaLabel || text}
    className={className}
    style={style}
    onClick={onClick}
  >
    {text}
  </button>
)

Button.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
}

export default Button
